/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindTraceabilityJobsByStatusQueryResponse,
  FindTraceabilityJobsByStatusPathParams,
} from "../types/FindTraceabilityJobsByStatus.ts"

export const findTraceabilityJobsByStatusQueryKey = (
  status: FindTraceabilityJobsByStatusPathParams["status"]
) =>
  [
    {
      url: "/v1/traceability-job/find-traceability-jobs-by-status/:status",
      params: { status },
    },
  ] as const

export type FindTraceabilityJobsByStatusQueryKey = ReturnType<
  typeof findTraceabilityJobsByStatusQueryKey
>

/**
 * @summary Find traceability jobs by status
 * {@link /v1/traceability-job/find-traceability-jobs-by-status/:status}
 */
export async function findTraceabilityJobsByStatus(
  status: FindTraceabilityJobsByStatusPathParams["status"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTraceabilityJobsByStatusQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-job/find-traceability-jobs-by-status/${status}`,
    ...requestConfig,
  })
  return res
}

export function findTraceabilityJobsByStatusQueryOptions(
  status: FindTraceabilityJobsByStatusPathParams["status"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTraceabilityJobsByStatusQueryKey(status)
  return queryOptions<
    ResponseConfig<FindTraceabilityJobsByStatusQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTraceabilityJobsByStatusQueryResponse>,
    typeof queryKey
  >({
    enabled: !!status,
    queryKey,
    queryFn: async ({ signal }) => {
      return findTraceabilityJobsByStatus(status, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find traceability jobs by status
 * {@link /v1/traceability-job/find-traceability-jobs-by-status/:status}
 */
export function useFindTraceabilityJobsByStatus<
  TData = ResponseConfig<FindTraceabilityJobsByStatusQueryResponse>,
  TQueryData = ResponseConfig<FindTraceabilityJobsByStatusQueryResponse>,
  TQueryKey extends QueryKey = FindTraceabilityJobsByStatusQueryKey,
>(
  status: FindTraceabilityJobsByStatusPathParams["status"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTraceabilityJobsByStatusQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findTraceabilityJobsByStatusQueryKey(status)

  const query = useQuery(
    {
      ...findTraceabilityJobsByStatusQueryOptions(status, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
